// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"97d3b325","214":"b0a84a0b","473":"b3302edb","891":"f37846df"}[chunkId] + ".chunk.css";
};